module.exports = __webpack_public_path__ + "media/assets/images/icons/studies/leftCarouselArrow-b19e54acc09022eaa409f1c4be4984e3.svg";